export default {
  roundOnly: true,
  checkoutFormVariant: 'd',
  planSet: 'pricing-32',
  growthbookFeatures: ['supp', 'thankyou_tips'],
  sexologyUpsellEnabled: false,
};
